var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('timer-totals',{attrs:{"time_spent":_vm.time_spent,"time_since":_vm.time_since,"timer":_vm.timer,"timers":_vm.timers,"rateLimited":_vm.rateLimited,"ignoreLunch":_vm.ignoreLunch},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var duration = ref.duration;
var classes = ref.classes;
return [_c('span',{staticClass:"number",class:classes},[_vm._v(_vm._s(_vm._f("formatDuration")(duration)))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }